import React, { memo, forwardRef } from "react";
const SvgSubtraction = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 16h18"
      />
    </svg>
  );
});
SvgSubtraction.displayName = "SvgSubtraction";
const MemoForwardRef = memo(SvgSubtraction);
export default MemoForwardRef;
